if (!customElements.get('caene-mobile-video')) {
  customElements.define('caene-mobile-video', class extends HTMLElement {
    connectedCallback() {
      this.mobile = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.mount = () => {
        if (this.video || !this.mobile.matches) return;
        this.video = this.querySelector('template').content.querySelector('video').cloneNode(true);
        this.video.muted = true; this.video.defaultMuted = true; this.video.playsInline = true;
        this.video.addEventListener('playing', () => this.video.classList.add('is-ready'));
        this.video.addEventListener('error', () => this.video.classList.remove('is-ready'));
        this.append(this.video);
      };
      this.sync = () => {
        if (!this.mobile.matches) { this.video?.pause(); this.video?.remove(); this.video = null; return; }
        if (this.visible) this.mount();
        if (!this.video) return;
        if (this.visible && !this.motion.matches && !document.hidden) this.video.play().catch(() => {});
        else this.video.pause();
      };
      this.near = new IntersectionObserver(entries => { if (entries[0].isIntersecting) this.mount(); }, {rootMargin:'250px'});
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); }, {threshold:0.15});
      this.near.observe(this); this.observer.observe(this);
      this.mobile.addEventListener('change',this.sync); this.motion.addEventListener('change',this.sync);
      document.addEventListener('visibilitychange',this.sync);
    }
    disconnectedCallback() {
      this.video?.pause(); this.near?.disconnect(); this.observer?.disconnect();
      this.mobile?.removeEventListener('change',this.sync); this.motion?.removeEventListener('change',this.sync);
      document.removeEventListener('visibilitychange',this.sync);
    }
  });
}
